<template>
    <svg
        version="1.1"
        viewBox="0 0 284.4 76.7"
        style="enable-background: new 0 0 284.4 76.7"
        xml:space="preserve"
    >
        <g>
            <path
                fill="#00ADEE"
                d="M12.3,75.3c1,0.2,2,0.4,2.9,0.4c7.3,0,48.7-1.2,64.6-1.2s174.9,2.9,190,2.1c15-0.8,15.2-25.4,14.3-34.3
		c-0.8-8.9-1.2-10.5-1.2-22c0-4-4.3-15.5-12.7-16.2C225.6,0,110.8-0.6,92.8,0.4C71.3,1.7,29,0,14.8,0C0.6,0-0.6,11.4,0.2,18.3
		c0.8,6.9,0,33.3,0,33.3c-0.3,7.4,1,12.8,3.2,16.7C3.4,68.3,6.9,74.1,12.3,75.3z"
            />
            <g>
                <path
                    fill="#FFFFFF"
                    d="M52.8,38.8c-0.6,4.4-1.6,9-3.1,12.3c-2.2,5.2-4.6,6.8-9.5,6.7c-2.1,0-4.5-2-5.7-5.2c-1.5,3-3.2,5.2-6.8,5.1
			c-3.1,0-5.5-1.3-5.6-7.2c0-2.6-0.1-5.2-0.1-7.3c-0.1-5.4,0-8.5,0-13.5c0-1.2,0.3-5.5-1.3-5.6c-1.4-0.1-2.6,2.4-3.6,5
			c-1.4-0.3-2.5-0.6-3.7-1c1.1-4,3.5-11.1,10-9.9c1.4,0.3,2.8,0.3,3.5,3.4c0.6,2.3,0.3,22.5,0.5,24.9c0,5.5,2.5,4.8,3.4,4.4
			c1.6-0.6,2-2.3,3.3-4.8c0.1-1.4,0.2-5,0.1-7c-0.1-2.8,0.1-6.3,0.1-9.8l-0.1-10.8l5.8,0.2c0.1,3.3-0.1,25.5,0,28.3
			c0.1,5.5,2.5,4.8,3.4,4.4c1-0.5,1.9-2.8,2.5-4.9c2.2-7.2,3.1-14.9,3-19.7c-4.2,0.8-6.2-5.1-3.3-7.5c2-1.7,3.3-1.6,5.6-1.2
			c1,0.1,2,1.1,2.4,2.7c0.5,2,0.4,4.4,0.4,6.1C53.8,32.2,53.3,35.9,52.8,38.8z"
                />
                <path
                    fill="#FFFFFF"
                    d="M66.9,53.9c-0.7,1.8-2,3.1-3.1,3.4c-1.9,0.7-5,0.2-6.2-1.9c-1.6-2.9-1.6-8.4-1.5-14.6c0.1-5-0.2-7.2,2.8-9
			c2.2-1.4,5.3-1.8,7.5,1.2c0-0.6,0-2.4,0.2-2.9c1.8,0,2.7,0.1,4.5,0.3c-0.1,8.9-0.1,18,0.2,21.3c0.1,0.9,1.1,0.9,1.6,0.5
			c1.2-0.9,2.4-2.1,5-5.8c1,0.9,1.7,1.9,2.3,2.8C76.7,54.5,74,58,71,57.9C68.4,57.9,67.8,57.5,66.9,53.9z M66.4,37.5
			c-1.9-3.4-4.6-2.3-5.1-0.3c-0.8,3.1-0.5,11.8,0.4,14.1c0.5,1.3,2.8,0.9,4.7-2.6C66.4,43.6,66.5,42.1,66.4,37.5z"
                />
                <path
                    fill="#FFFFFF"
                    d="M90.2,46.7c0.8,0.8,1.6,1.8,2.2,2.8c-2.8,4.3-4.8,6.9-7.8,7.9c-3.5,1.2-7.8,0.4-7.5-4.4
			c0.5-8.8,0.9-13.3,1.3-21.7c1.4-0.2,3.6-0.1,5-0.1c-0.4,9-2,21-1.1,21.8C84.3,54.5,87.7,50,90.2,46.7z M83.5,27.2
			c-0.8,0.9-3.1,0.8-4.1,0.1c-1.5-0.9-1.8-3.1-1-4.6c1.2-2.4,4.9-2.2,5.9-0.2C85.1,24,84.4,26.3,83.5,27.2z"
                />
                <path
                    fill="#FFFFFF"
                    d="M103.1,31c3,1.2,2.6,8.4,2.1,14.7c-0.2,2.3-0.3,6.2-0.1,6.5c0.6,1.2,3.6-1,7.1-6.3c0.6,0.5,1.6,1.5,2.3,2.8
			c-3,4.9-4.8,6.9-7.4,8.4c-1.9,1.1-6.9,1.3-6.9-1.9c0-4.6,0.4-11.1,0.5-16.8c0.1-3.8-3.5-2.2-5.8,1.9c-0.1,2.6-0.2,3.1-0.3,4.5
			c-0.4,4.2-0.3,8.2-0.6,12c-1.1,0-3.4,0.2-4.8,0.2c0.4-6.8,0.6-15.4,0.9-18.5c0.2-3.1,0.7-14.3,0.8-17.1c0.2-2.2-0.1-7.2,4.2-8.6
			c1.8-0.5,7.4-1.1,8,3.9c0.3,2.3-1.1,5.6-2.9,8.6c-0.9,1.5-2.4,3.4-5,6.1c-0.1,0.7-0.1,2.8-0.2,3.2C97.9,30.9,100.8,30.1,103.1,31z
			 M95.3,26.4c1.9-2.5,3.1-5.6,3.4-6.5c1-3.8-2.8-4.2-3-1.6C95.4,20.8,95.3,23.3,95.3,26.4z"
                />
                <path
                    fill="#FFFFFF"
                    d="M116.4,45c0,2.6-0.1,5.6,1.4,7c2,1.9,6.4,3.4,12.1-5.8c0.8,0.7,1.8,1.6,2.4,2.8c-2.6,4.5-6.3,8.2-9.5,8.8
			c-4.4,0.8-7.4-0.9-8.2-1.5c-3-2.5-2.8-9.3-2.8-13.8c0-4.3-0.6-8.8,2.8-11.2c2.4-1.7,7.7-1.4,9.4,1c1.8,2.6,2.1,8.3-0.8,10.5
			C120.6,44.6,118.9,44.8,116.4,45z M117.7,34.4c-1.9,1-1.5,4.5-1.5,6.2c1.2,0.2,3-0.2,4.1-1.1c0.8-0.7,1.1-2.4,0.6-3.7
			C120.5,34.5,119.3,33.7,117.7,34.4z"
                />
                <path
                    fill="#FFFFFF"
                    d="M140.8,30.9c4.1-0.1,5.6,1.9,5.7,5.9c0.1,4-3.8,8.5-7,9.4c2.6,3.4,4.5,6.4,5.7,6.5c1.7,0.2,2.5-1.2,6.2-6.3
			c0.7,0.7,1.7,1.7,2.3,2.7c-3.6,5.7-6,8.9-8.6,8.8c-1.1,0-2.8-0.6-3.8-1.6c-1.1-1.1-2-2.1-4.1-5.3c-0.9-1.3-2.1-3.1-2.8-4.4
			c0,2.3,0.1,8.2,0.4,10.7c-1.1,0-1.7,0-4.7,0l-1.2-34.9c-0.1-2.2-0.3-7.4,2.6-8.8c1.8-0.9,7.6-1.5,8.8,3.2c0.8,2.8-0.6,6.3-2.1,9.1
			c-1.4,2.7-2.1,3.6-4.2,6.6c0,1.4,0.1,3.9,0.1,4.5C135.4,34.4,138.1,30.9,140.8,30.9z M133.5,26.6c1.3-2.6,2.5-5.4,2.7-6.5
			c0.6-3.8-2.8-3.5-2.8-0.6C133.3,21.4,133.2,23.5,133.5,26.6z M135.4,42.3c3.1-0.1,4.9-1.6,6.7-4.2c1-1.4-0.6-3.4-2.2-2.1
			C137.3,38.2,135.9,41.2,135.4,42.3z"
                />
                <path
                    fill="#FFDD15"
                    d="M176.6,57.1c-1,0.9-2.7,1.1-4.1,0.3c-1.7-1-2.6-2.8-2-4.7c1-3.1,5.3-2.8,6.7-0.5
			C178.4,54,177.5,55.6,176.6,57.1z"
                />
                <path
                    fill="#FFDD15"
                    d="M190.6,35.4c-1.9,0-4.4-0.3-5.3,2.3c-0.9,2.6-0.1,8.8,0.3,12.6c0.6,2.1,2.3,3.2,3.8,3.1
			c1.9,0,3.4-0.8,7.3-6.8c0.6,0.6,1.7,1.8,2.3,2.8c-4.9,7.7-6.9,8.8-11.3,8.4c-2.9-0.2-5.7-1.8-6.5-4c-0.5-1.2-0.8-3.1-0.8-4.4
			c-0.2-5.8-1-13.1,0.8-15.9c1.9-2.8,5.7-3.1,9.3-2.6C190.6,32,190.6,34.2,190.6,35.4z"
                />
                <path
                    fill="#FFDD15"
                    d="M220.7,57.1c-1,0.9-2.7,1.1-4.1,0.3c-1.7-1-2.6-2.8-2-4.7c1-3.1,5.3-2.8,6.7-0.5
			C222.5,54,221.6,55.6,220.7,57.1z"
                />
                <path
                    fill="#FFDD15"
                    d="M211.3,39.1c1,0,2-0.1,2.9-0.2l-0.5-4.2c-1.1,0.1-2.1,0.1-3.1-0.1c-0.4-4.7-7.6-4.1-9.4-4
			c-3,0.1-5.3,1.1-5.3,3.8c0.1,3.4,0.2,6.3,0.4,9.8c0.1,3.3,0.4,8.4,0.8,10.3c0.6,2.5,4.7,3.4,7.2,3.4c3.5,0,5.8-0.9,6.7-3
			c0.6-1.1,0.6-3.9,0.5-8.1C211.5,45.6,211.5,41.6,211.3,39.1z M206.9,52.3c-0.3,1.8-4.1,1.6-4.8,0.5c-0.6-0.9-0.9-11.1-1.1-16
			c-0.1-1.6,0.6-2.7,3.3-2.5c-0.7,0.7-0.8,2.1-0.4,3.2c0.5,1.1,1,1.5,2.7,1.7C207,45.3,207.1,50.9,206.9,52.3z"
                />
                <path
                    fill="#FFFFFF"
                    d="M166.2,50.3c-4.1,4.4-7.3,3.2-9,1.6c-1.5-1.4-1.3-4.4-1.4-7c2.5-0.2,4.2-0.4,6.7-2.3c2.9-2.3,2.6-8,0.8-10.5
			c-1.7-2.4-7-2.7-9.4-1c-3.4,2.4-2.9,6.9-2.8,11.2c0,4.5-0.1,11.3,2.8,13.8c0.8,0.7,3.8,2.3,8.2,1.5c2-0.4,4.3-2,6.2-4.2
			C167.8,52.7,166.9,51.3,166.2,50.3z M157.1,34.4c1.5-0.8,2.8,0.1,3.2,1.4c0.5,1.3,0.2,3-0.6,3.7c-1.1,0.9-2.8,1.3-4.1,1.1
			C155.6,38.9,155.2,35.4,157.1,34.4z"
                />
                <path
                    fill="#FFDD15"
                    d="M266,48.3c-2.8-3.1-5.9-2.1-7.1-0.8c-1.1,1.3-0.3,4.5,1.9,4.5s2.7-1.2,2.7-1.2c1.5,3.1-2.2,3.3-5.3,2.9
			c-3.1-0.4-5.3-0.6-5.3-0.6s0.9-2.1,2.6-4.4c1.3-1.8,3.1-3.4,5.2-6.4c4.8-6.7,3.5-11.6,3.5-11.6s-2.4,1.3-6.1,1.8
			c-3.7,0.5-6.2-1.2-8.7-1.2c-2.5,0-5.3,1.8-5.3,1.8l1.8,4.7c3.1-2,5-1.8,7.9-1.1c2.9,0.8,4.3,0.5,4.3,0.5
			c-0.9,4.4-7.8,9.6-10.7,13.1c-1.2,1.5-4.1,6.4,3,7c3.1-0.1,7.3,0,11.2,0.6C268.6,58.9,268.7,51.4,266,48.3z"
                />
                <path
                    fill="#FFDD15"
                    d="M242.3,57.4c2.3-0.8,4.2-2.3,4.2-2.3l-0.3-3.1c-2.8,1.4-3.9,1-4.4,0.6c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.2
			c0,0,0-0.1-0.1-0.1c-0.3-0.7-0.2-6.1-0.1-8.4c0.2-4.2,0.9-11.5-2.2-12.5c-3.1-1-6.9,1-8.5,3.2c0-1.6,0-2.7-0.1-3.9
			c-1.4,0-3,0-4.6,0.2l-0.5,26.6c1.9,0,3,0.2,5,0c0-6.6,0-11.3,0.2-17.2c0.9-2.4,5.6-5.7,5.7-2.6c0.3,6.2-0.3,9.1-0.1,16
			c0,2.3,0.9,3.4,2.1,3.9c0.3,0.1,0.6,0.2,1.2,0.2c0,0,0,0,0,0C240.5,57.9,241.5,57.7,242.3,57.4z"
                />
            </g>
        </g>
    </svg>
</template>
